const loadBabel = (() => {
	return {
		isLoaded: false,
		load: async () => {
			await Promise.all([
				LinkVue.resource.loadLib('Babel'),
				LinkVue.resource.loadLib('BabelPluginTransformVueJsx'),
			])
			loadBabel.isLoaded = true
		}
	}
})()

export default {
	name: 'link-document-item-demo-instance',
	props: {
		html: {},
		js: {},
		css: {},
	},
	data() {
		return {
			hasLoadDependency: loadBabel.isLoaded,
		}
	},
	render(h) {

		if (!this.hasLoadDependency) {
			loadBabel.load().then(() => this.hasLoadDependency = true)
			return '正在加载......'
		}

		const ret = {template: `<div class="link-document-item-demo-instance">${this.html || ''}</div>`,}

		if (!!this.js && this.js.trim().length > 0) {
			const output = window.Babel.transform(this.js, {
					presets: [
						'latest', 'stage-0'
					],
					plugins: [window.BabelPluginTransformVueJsx]
				}
			).code;
			const fn = new Function('module,exports', output)
			const module = {
				exports: {default: undefined},
			}
			fn.call(module, module, module.exports)
			Object.assign(ret, module.exports.default)
		}
		if (!!this.css) {
			const style = document.createElement("style")
			style.innerHTML = this.css
			document.head.appendChild(style)
		}
		return h(this.$lv.Vue.extend(ret))
	},
}
